import { TableCard } from 'app/components'
import { LogsUsuarioHeading } from './components/LogsUsuarioHeading'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { LogsUsuarioIdTable } from './table/LogsUsuarioIdTable'

const LogsUsuarioIdList = () => {
  return (
    <>
      <LogsUsuarioHeading />
      <TableCard>
        <LogsUsuarioIdTable />
      </TableCard>
    </>
  )
}

export const LogsUsuarioIdListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <LogsUsuarioIdList />
    </QueryResponseProvider>
  </QueryRequestProvider>
)
